import React from "react";
import {Button, CardHeader, InputAdornment, TextField,} from "@material-ui/core";
import {store} from "../store";
import Loading from "../Loading";

const Amount = () => {
    const [amount, setAmount] = React.useState("");
    const [error] = React.useState(false);
    const [loading] = React.useState(false);

    const globalState = React.useContext(store);
    const {setState: setGlobalState} = globalState;

    const updateTextField = e => {
        const value = e.target.value;

        let money = value.replace(/[\D\s._-]+/g, "");
        money = money ? parseInt(money, 10) : 0;
        // let money = value;

        setAmount(money);
        setGlobalState({_path: "amount", _value: money});
    };

    let amountError = false;
    if (error === "amountError") {
        amountError = true;
    }

    const handleSubmit = e => {
        e.preventDefault();
        setGlobalState({_path: "progress", _value: "payment"});
    };

    const goBack = e => {
        e.preventDefault();

        setGlobalState({_path: "progress", _value: "lookup"});
        setGlobalState({_path: "account.number", _value: false});
    };

    return (
        <React.Fragment>
            <div style={{textAlign: "left", width: "100%", fontSize: "10px"}}>
                <button onClick={goBack}>&laquo; Back</button>
            </div>
            <CardHeader
                title="Add Funds"
                subheader="Enter the amount you would like to add to the selected account."
            />
            <br/>
            <TextField
                required
                type="text"
                onChange={updateTextField}
                label="Amount"
                id="reload-amount"
                value={amount}
                error={amountError}
                helperText=""
                InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                }}
            />
            <div className="action">
                <Button
                    disabled={!amount}
                    className="submit"
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Continue
                </Button>
                {loading === true && <Loading/>}
            </div>
        </React.Fragment>
    );
};

export default Amount;
